import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

// The kinds of change order a tenant defines. These are OBJECT TYPES whose classification is
// "ChangeOrder" -- a change order is typed exactly as a record is -- so this reads the ordinary
// object_types endpoint with that classification fixed.
class ChangeOrderTypeEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "ChangeOrderType";
        this.defaultCacheSize = 100;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata("USID", false, true, true, false, null, null, null, 36, null, null, "UUID", null, false);
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata("Name", false, true, false, false, null, null, null, null, null, null, "String", null, false);
        this.attributes["Acronym"] = new EnterpriseComponentAttributeMetadata("Acronym", false, true, false, false, null, null, null, 20, null, null, "String", null, false);
        this.attributes["ObjectClassification"] = new EnterpriseComponentAttributeMetadata("ObjectClassification", false, true, false, false, null, null, null, 40, null, null, "String", null, false);
        this.attributes["Active"] = new EnterpriseComponentAttributeMetadata("Active", false, true, false, false, null, null, null, null, null, null, "Boolean", null, false);
    }
}

export default ChangeOrderTypeEnterpriseComponentMetadata;
